export default {"src":"/_next/static/media/instacart-color.8a96b72e.svg","height":22,"width":136,"blurWidth":0,"blurHeight":0};